import { Link } from "react-router-dom";
import { Mail, Phone, MapPin } from "lucide-react";
import { Logo } from "@/components/site/Header";
import { useLang } from "@/lib/i18n";
import { CONTACT_EMAIL, WHATSAPP_DISPLAY, WHATSAPP_URL } from "@/lib/api";

export default function Footer() {
  const { t } = useLang();
  return (
    <footer id="contacto" className="bg-[#06141D] text-white/80 relative grain">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-20 grid gap-14 md:grid-cols-[1.4fr_1fr_1fr_1fr]">
        <div>
          <Logo />
          <p className="mt-6 max-w-sm text-sm leading-relaxed text-white/60">{t("footer.tagline")}</p>
        </div>
        <div>
          <p className="eyebrow !text-[#D4AF37]">{t("footer.contact")}</p>
          <ul className="mt-5 space-y-4 text-sm">
            <li><a href={WHATSAPP_URL} target="_blank" rel="noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-3 hover:text-[#00D2C8] transition-colors"><Phone className="h-4 w-4 text-[#00D2C8]" />{WHATSAPP_DISPLAY}</a></li>
            <li><a href={`mailto:${CONTACT_EMAIL}`} data-testid="footer-email-link" className="flex items-center gap-3 break-all hover:text-[#00D2C8] transition-colors"><Mail className="h-4 w-4 shrink-0 text-[#00D2C8]" />{CONTACT_EMAIL}</a></li>
            <li className="flex items-center gap-3"><MapPin className="h-4 w-4 text-[#00D2C8]" />Cancún, Quintana Roo, México</li>
          </ul>
        </div>
        <div>
          <p className="eyebrow !text-[#D4AF37]">{t("footer.explore")}</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/yachts" className="hover:text-white transition-colors">{t("nav.yachts")}</Link></li>
            <li><Link to="/tours" className="hover:text-white transition-colors">{t("nav.tours")}</Link></li>
            <li><Link to="/admin/login" data-testid="footer-admin-link" className="text-white/40 hover:text-white/80 transition-colors">{t("footer.admin")}</Link></li>
          </ul>
        </div>
        <div>
          <p className="eyebrow !text-[#D4AF37]">{t("footer.legal")}</p>
          <ul className="mt-5 space-y-3 text-sm">
            <li><Link to="/terminos" data-testid="footer-terms-link" className="hover:text-white transition-colors">{t("legal.terms")}</Link></li>
            <li><Link to="/terminos#cancelaciones" data-testid="footer-cancel-link" className="hover:text-white transition-colors">{t("legal.cancel")}</Link></li>
            <li><Link to="/privacidad" data-testid="footer-privacy-link" className="hover:text-white transition-colors">{t("legal.privacy")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-white/10 py-6 text-center text-xs text-white/40">
        © {new Date().getFullYear()} Legendary Vacational Club. {t("footer.rights")}
      </div>
    </footer>
  );
}
